

export const defaultShipmentMapFilters = {
    shipmentMerchant: ["all"],
    shipmentType: ["all"],
    shipmentOrderStatus: ["ready_for_delivery",],
    shipmentHubOpen: "all",
    shipmentReadySince: 0,
    shipmentDateFrom: "",
    shipmentDateTo: "",
    hubIds: ["all"],
    shipmentPaymentMethod: ["all"],
    startingDistance: null,
    endingDistance: null,
}

export const defaultDriverMapFilters = {
    driverCity: "all",
    shiftTemplateId: "all",
    driverDevice: "all",
    driverVehicle: "all",
    driverUniform: "all",
    driverStatus: "all",
    driverLastSeen: 30,
}

export const defFilters = {
    ...defaultShipmentMapFilters,
    ...defaultDriverMapFilters
};

export function getFilterOptions(t, cityIds) {
    return [
        {
            name: t("filter_by_city"),
            value: "city",
            id: 1,
            options: cityIds,
        },
        {
            name: t("filter_by_vehicle"),
            value: "vehicle",
            id: 2,
            options: [
                { value: 0, label: t("car") },
                { value: 1, label: t("motorbike") },
                { value: 2, label: t("van") },
                { value: 3, label: t("minivan") },
                { value: 4, label: t("pickup") },
                { value: 5, label: t("small_truck") },
                { value: 6, label: t("large_truck") },
            ],
        },
        {
            name: t("filter_by_device"),
            value: "device",
            id: 4,
            options: [
                { value: "android", label: t("android") },
                { value: "ios", label: t("ios") },
            ],
        },
        {
            name: t("filter_by_dress"),
            value: "dress",
            id: 6,
            options: [
                { value: 0, label: t("branded") },
                { value: 1, label: t("unbranded") },
            ],
        },
        {
            name: t("filter_by_status"),
            value: "status",
            id: 7,
            options: [
                { value: "free", label: t("Online available") },
                { value: "busy", label: t("Online busy") },
                { value: "offline", label: t("Offline") },
            ],
        },
    ];
}